import { render } from "./BudgetSheetPlan.vue?vue&type=template&id=07f5874c"
import script from "./BudgetSheetPlan.vue?vue&type=script&lang=js"
export * from "./BudgetSheetPlan.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__